// utils/xml.ts
import { XMLParser, type X2jOptions } from "fast-xml-parser";

export type XmlToJsonOptions = X2jOptions;

export const defaultXmlOptions: XmlToJsonOptions = {
    ignoreAttributes: false,
    attributeNamePrefix: "@_",
    allowBooleanAttributes: true,
    parseAttributeValue: true,
    parseTagValue: true,
    trimValues: true,
    cdataPropName: "#cdata",        // CDATA -> propiedad especial
    // Si un tag se repite, obtendrás un array automáticamente:
    isArray: (name, jpath, isLeafNode, isAttr) => false, // deja el comportamiento por defecto
    // Convierte números de forma segura:
    numberParseOptions: {
        leadingZeros: true,
        hex: false,
        skipLike: /\d{16,}/
    }
};

export function xmlToJson<T = unknown>(
    xml: string,
    options: XmlToJsonOptions = defaultXmlOptions
): T {
    const parser = new XMLParser(options);
    return parser.parse(xml) as T;
}